import React from 'react';
import Button from '@material-ui/core/Button';
import DialogApp, { DialogAppTitle, DialogAppContent, DialogAppActions } from 'components/DialogApp';

const FooterDialog = ({
  open,
  handleClose,
  title,
  content,
}) => {
  return (
    <DialogApp
      open={open}
      onClose={handleClose}
    >
      <DialogAppTitle>
        {title}
      </DialogAppTitle>

      <DialogAppContent>
        {content}
      </DialogAppContent>

      <DialogAppActions>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
        >
          Close
        </Button>
      </DialogAppActions>
    </DialogApp>
  );
};

export default FooterDialog;



// WEBPACK FOOTER //
// ./src/components/landing/components/footer/components/FooterDialog/FooterDialog.js